export const getMinDeadline = (): string => {
    const date = new Date();
    date.setDate(date.getDate() + 1);
    return date.toISOString().slice(0, 10);
}

export const getDeadlineError = (deadline: string): string => {
    return deadline < getMinDeadline() ? "Wunschtermin muss in der Zukunft liegen" : ''
}

export const isDeadlineValid = (deadline: string): boolean => {
    return getDeadlineError(deadline).length < 1
}

export interface DeliveryInfo {
    desiredSchedule: string;
    description: string;
    street: string;
    zip: string | number;
    city: string;
}

export interface ProjectWithDelivery {
    delivery: DeliveryInfo;
}

export const isDeliveryValid = (project: ProjectWithDelivery): boolean => {
    return !!isDeadlineValid(project.delivery.desiredSchedule)
        && !!project.delivery.description
        && !!project.delivery.street
        && !!project.delivery.zip
        && !!project.delivery.city
}

